import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserUtils } from "@azure/msal-browser";
import { App } from "./App";
import { Config } from "./Config";
import "./styles.css";

// Nach der Anmeldung schickt Microsoft das Pop-up-Fenster auf UNSERE
// Adresse zurück. Würde dort die ganze App starten, begänne sie ihrerseits
// eine Anmeldung – das Fenster bliebe stehen und das Ergebnis käme nie im
// Hauptfenster an.
//
// WICHTIG: nur auf Pop-ups prüfen, NICHT auf Rahmen (iframe). In Teams
// läuft die App selbst in einem Rahmen – eine Rahmen-Prüfung würde die
// App dort vollständig lahmlegen.
if (!BrowserUtils.isInPopup()) {
  // Zwei Seiten, kein Router: /config ruft Teams beim Hinzufügen des Tabs
  // auf, alles andere ist die Zeitleiste selbst.
  const istKonfiguration = window.location.pathname.startsWith("/config");

  createRoot(document.getElementById("root")!).render(
    <StrictMode>{istKonfiguration ? <Config /> : <App />}</StrictMode>,
  );
}
